<div class="container py-3">

  <!-- Cabecera -->
  <div class="d-flex align-items-center justify-content-between flex-wrap mb-3">
    <div class="d-flex align-items-center">
      <button *ngIf="vista === 'form'" class="btn btn-link mr-2 p-0 volver-btn" (click)="volverAAgenda()">
        ← Volver
      </button>
      <h4 class="mb-0" style="font-family: 'Mulish' !important;">
        {{ vista === 'agenda' ? 'Agenda del día' : 'Agendar hora' }}
      </h4>
    </div>

    <div class="form-inline" *ngIf="vista === 'agenda'">
      <label class="mr-2 mb-2" style="font-family: 'Mulish' !important;">Fecha:</label>
      <input type="date" class="form-control mb-2" [(ngModel)]="selectedDate" (change)="onFechaChange()" />
    </div>
  </div>

  <!-- Vista Agenda -->
  <ng-container *ngIf="vista === 'agenda'">

    <!-- Loader -->
    <div class="col" *ngIf="isLoading" style="min-height: 60px;">
      <div class="loader">
        <div class="loader__figure"></div>
        <p class="loader__label"></p>
      </div>
    </div>

    <!-- Sin horas (para vista normal y para hora_siguiente vacía) -->
    <div *ngIf="!isLoading && (selectedView === 'paciente' ? hora_siguiente.length === 0 : horas_del_dia.length === 0)"
      class="card-alerta">
      <table>
        <tr>
          <td class="p-3">
            <i class="fi fi-rr-info"
              style="color: #1a237e; font-size: larger; display: flex; justify-content: center;"></i>
          </td>
          <td>
            <p class="letras-alerta">
              {{ selectedView === 'paciente'
              ? 'No hay una próxima hora disponible para hoy.'
              : 'No existen horas disponibles para este día.' }}
            </p>
          </td>
        </tr>
      </table>
    </div>

    <!-- Horas disponibles -->
    <div *ngIf="!isLoading && (selectedView === 'paciente' ? hora_siguiente.length > 0 : horas_del_dia.length > 0)">
      <div *ngFor="let slot of (selectedView === 'paciente' ? hora_siguiente : slots)" class="mb-2">

        <!-- Card con cita -->
        <div *ngIf="slot.cita; else disponible" class="card shadow-sm slot-card" [ngClass]="{
           'slot-card-agendada': !slot.cita?.esOnDemand,
           'slot-card-ondemand': slot.cita?.esOnDemand
         }" style="border-radius: 6px;">


          <div class="card-body p-3 d-flex justify-content-between align-items-start">
            <!-- Izquierda -->
            <div>
              <div class="mb-1" style="font-weight: 600;">
                {{ slot.cita?.datosPacienteConsulta?.use_name || 'Disponible' }}
                {{ slot.cita?.datosPacienteConsulta?.use_paternal_surname || '' }}
              </div>
              <div class="text-muted small">
                {{ slot.cita?.datosPacienteConsulta?.spe_name || '' }}
              </div>
            </div>

            <!-- Derecha -->
            <div class="text-right small text-nowrap">
              <div style="font-size: 12px;">
                {{ slot.cita?.hora_inicio }} - {{ slot.cita?.hora_fin }}
              </div>
              <div class="font-weight-bold mb-1">
                <span class="ml-2" style="font-size: 12px;" [class]="badgeClass(slot.cita?.estado)">
                  {{ slot.cita?.esOnDemand ? 'A. INMEDIATA' : slot.cita?.estado }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Card disponible -->
       <ng-template #disponible>
  <div
  class="card shadow-sm slot-card disponible"
  style="border-radius: 6px;"
  [ngClass]="{
    'slot-card-ondemand': !!slot?.sch_is_ondemand,
    'slot-card-agendada': !slot?.sch_is_ondemand
  }">


    <div class="card-body p-3 d-flex justify-content-between align-items-start">

      <!-- Izquierda -->
      <div>
        <div class="mb-1" style="font-weight: 600; font-family: 'Mulish';">
          Disponible
        </div>
        <div class="text-muted small"></div>
      </div>

      <!-- Derecha -->
      <div class="text-right small text-nowrap">
        <div style="font-size: 12px;">
          {{ slot.hora }} - {{ slot.horaFin || '' }}
        </div>

        <div class="font-weight-bold mb-1">
          <span class="ml-2" style="font-size: 12px;" class="badge badge-info">
            {{ slot?.sch_is_ondemand ? 'A. INMEDIATA' : 'DISPONIBLE AGENDAMIENTO' }}
          </span>
        </div>

        <!-- Botón si quieres -->
        <!--
        <button type="button" class="btn btn-outline-primary btn-sm" (click)="iniciarAgendar(slot)">
          Agendar
        </button>
        -->
      </div>

    </div>
  </div>
</ng-template>

      </div>
    </div>

  </ng-container>

  <!-- Vista Formulario -->
  <ng-container *ngIf="vista === 'form' && slotSeleccionado">
    <div class="card shadow-sm">
      <div class="card-body">
        <div class="mb-3 text-muted small">
          <strong>Fecha seleccionada:</strong> {{ selectedDate }} &nbsp;|&nbsp;
          <strong>Hora:</strong> {{ slotSeleccionado.hora }}
        </div>

        <form [formGroup]="formAgendar" (ngSubmit)="guardarAgendamiento()" novalidate>
          <div class="form-row">
            <div class="form-group col-md-6">
              <label>Paciente</label>
              <input formControlName="paciente" type="text" class="form-control"
                [class.is-invalid]="formAgendar.get('paciente')?.invalid && formAgendar.get('paciente')?.touched">
              <div class="invalid-feedback">Ingresa el nombre del paciente (mín. 3 caracteres).</div>
            </div>

            <div class="form-group col-md-6">
              <label>Motivo / Especialidad</label>
              <input formControlName="motivo" type="text" class="form-control" placeholder="Ej: Medicina General"
                [class.is-invalid]="formAgendar.get('motivo')?.invalid && formAgendar.get('motivo')?.touched">
              <div class="invalid-feedback">Ingresa el motivo o especialidad.</div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-6">
              <label>Teléfono</label>
              <input formControlName="telefono" type="tel" class="form-control"
                [class.is-invalid]="formAgendar.get('telefono')?.invalid && formAgendar.get('telefono')?.touched">
              <div class="invalid-feedback">Ingresa un teléfono de contacto.</div>
            </div>

            <div class="form-group col-md-6">
              <label>Email</label>
              <input formControlName="email" type="email" class="form-control"
                [class.is-invalid]="formAgendar.get('email')?.invalid && formAgendar.get('email')?.touched">
              <div class="invalid-feedback">Ingresa un email válido.</div>
            </div>
          </div>

          <div class="text-right">
            <button type="button" class="btn btn-light mr-2" (click)="volverAAgenda()">Cancelar</button>
            <button type="submit" class="btn btn-primary">Guardar</button>
          </div>
        </form>
      </div>
    </div>
  </ng-container>
</div>